var map = {
	"./angbao-bonus-thaipusam.webp": 2500,
	"./angbao-bonus.webp": 2501,
	"./angbao-bonus_dewali.webp": 2502,
	"./cny-lucky-draw.webp": 2503,
	"./cny-promo.webp": 2504,
	"./dewali-promo.webp": 2505,
	"./fifa-logo.webp": 2506,
	"./fifa-prediction.webp": 2507,
	"./fifa-qna.webp": 2508,
	"./raya-promo.webp": 2509,
	"./welcome-cny-bonus.webp": 2510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2499;